import { render, staticRenderFns } from "./eventsTable.vue?vue&type=template&id=3392279d&scoped=true&"
import script from "./eventsTable.vue?vue&type=script&lang=js&"
export * from "./eventsTable.vue?vue&type=script&lang=js&"
import style0 from "./eventsTable.vue?vue&type=style&index=0&id=3392279d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3392279d",
  null
  
)

export default component.exports